module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg6": "",
      "offset-lg3": ""
    }
  }, [_c('v-expansion-panel', {
    staticClass: "mb-2",
    attrs: {
      "popout": "",
      "dark": ""
    }
  }, [_c('v-expansion-panel-content', {
    staticClass: "blue-grey",
    attrs: {
      "lazy": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('strong', [_vm._v("Job Details")])]), _vm._v(" "), _c('v-card', [_c('v-list', {
    staticClass: "blue-grey"
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Customer: " + _vm._s(_vm.customerName))])], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Vehicle: " + _vm._s(_vm.currentJob.vehicle ? _vm.vehicleRegFromID(_vm.currentJob.vehicle) : _vm.currentJob.reg))])], 1)], 1), _vm._v(" "), (_vm.currentJob.requirements) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Requirements: " + _vm._s(_vm.currentJob.requirements))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentJob.network) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Network: " + _vm._s(_vm.currentJob.network))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentJob.APN) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("APN: " + _vm._s(_vm.currentJob.APN))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentJob.newReg) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("New Reg: " + _vm._s(_vm.currentJob.newReg))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentJob.newMake) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("New Make: " + _vm._s(_vm.currentJob.newMake))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentJob.newModel) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("New Model: " + _vm._s(_vm.currentJob.newModel))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentJob.leaveKit) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Where to leave kit: " + _vm._s(_vm.currentJob.leaveKit))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentJob.getKit) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Where to get kit: " + _vm._s(_vm.currentJob.getKit))])], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', {
    attrs: {
      "popout": "",
      "dark": ""
    }
  }, _vm._l((_vm.templates), function(item, i) {
    return _c('v-expansion-panel-content', {
      key: i,
      class: _vm.checkListComplete(i),
      attrs: {
        "lazy": ""
      }
    }, [_c('div', {
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('strong', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('v-card', [_c('v-list', {
      attrs: {
        "three-line": ""
      }
    }, [_vm._l((_vm.templates[i].items), function(subitem, index) {
      return _c('v-list-group', {
        key: index,
        attrs: {
          "lazy": "",
          "avatar": "",
          "value": true
        }
      }, [(subitem.text !== undefined && subitem.text.indexOf('c.isni.co') !== -1 && !subitem.test) ? _c('v-list-tile', [_c('a', {
        staticClass: "cyan--text",
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.gotoIsniTestPage.apply(null, arguments)
          }
        }
      }, [_vm._v(" Visit Test Site"), _c('v-icon', [_vm._v("open_in_new")])], 1)]) : _vm._e(), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', {
        attrs: {
          "icon": "",
          "color": (subitem.image && subitem.image.length > 0) || (subitem.note && subitem.note.length > 0) > 0 ? 'green' : 'grey'
        },
        domProps: {
          "innerHTML": _vm._s(_vm.listIcon(subitem))
        }
      })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
        staticClass: "mb-2"
      }, [_vm._v(_vm._s(subitem.title))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(subitem.text))])], 1), _vm._v(" "), (!subitem.optional === true) ? _c('v-list-tile-action', [_c('v-icon', {
        attrs: {
          "color": "grey lighten-1"
        }
      }, [_vm._v("visibility")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile', [(subitem.photo && !subitem.test) ? [(subitem.image) ? _c('img', {
        attrs: {
          "src": _vm.imageObj[subitem.image],
          "height": "80"
        },
        on: {
          "click": function($event) {
            return _vm.openFullImage(_vm.imageObj[subitem.image], i, index)
          }
        }
      }) : _c('v-btn', {
        attrs: {
          "loading": _vm.imageProcessing,
          "color": "primary"
        },
        on: {
          "click": function($event) {
            return _vm.triggerPick(i, index, 'photo')
          }
        }
      }, [_c('v-icon', [_vm._v("add_a_photo")]), _vm._v(_vm._s(subitem.image ? ' Change Photo' : ' Add Photo'))], 1)] : _vm._e(), _vm._v(" "), (!subitem.test) ? [(subitem.note) ? _c('p', {
        staticClass: "pa-1 mb-0 ml-1 white black--text",
        staticStyle: {
          "overflow": "hidden",
          "display": "-webkit-box",
          "box-orient": "vertical",
          "line-clamp": "3",
          "height": "80px",
          "width": "100%"
        },
        on: {
          "click": function($event) {
            return _vm.triggerPick(i, index, 'note')
          }
        }
      }, [_vm._v(_vm._s(subitem.note))]) : _c('v-btn', {
        attrs: {
          "color": "primary",
          "disabled": subitem.photo && subitem.image.length < 1
        },
        on: {
          "click": function($event) {
            return _vm.triggerPick(i, index, 'note')
          }
        }
      }, [_c('v-icon', [_vm._v("note_add")]), _vm._v(_vm._s(subitem.note ? ' Change Note' : ' Add Note'))], 1)] : _vm._e(), _vm._v(" "), (subitem.test) ? _c('v-btn', {
        attrs: {
          "color": "primary"
        },
        on: {
          "click": function($event) {
            return _vm.gotoTestPage(i, index)
          }
        }
      }, [_c('v-icon', [_vm._v("mdi-cloud-check")]), _vm._v(" Run Test")], 1) : _vm._e()], 2)], 1)
    }), _vm._v(" "), (item.name === 'Lisle RDL') ? _c('v-list-group', {
      attrs: {
        "lazy": "",
        "avatar": "",
        "value": true
      }
    }, [_c('v-list-tile', [_c('v-btn', {
      attrs: {
        "color": "primary",
        "block": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.rdlTest()
        }
      }
    }, [_vm._v("Test RDL")])], 1)], 1) : _vm._e(), _vm._v(" "), (item.name === 'Digi-DL') ? _c('v-list-group', {
      attrs: {
        "lazy": "",
        "avatar": "",
        "value": true
      }
    }, [_c('v-list-tile', [_c('v-btn', {
      attrs: {
        "color": "primary",
        "block": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.dlTest()
        }
      }
    }, [_vm._v("Test DL")])], 1)], 1) : _vm._e()], 2)], 1)], 1)
  }), 1), _vm._v(" "), _c('v-textarea', {
    staticClass: "mx-2",
    attrs: {
      "label": "General Notes"
    },
    on: {
      "change": _vm.saveJob
    },
    model: {
      value: (_vm.currentJob.notes),
      callback: function($$v) {
        _vm.$set(_vm.currentJob, "notes", $$v)
      },
      expression: "currentJob.notes"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "mx-2",
    attrs: {
      "label": "Is this job chargeable?"
    },
    on: {
      "change": _vm.saveJob
    },
    model: {
      value: (_vm.currentJob.chargeable),
      callback: function($$v) {
        _vm.$set(_vm.currentJob, "chargeable", $$v)
      },
      expression: "currentJob.chargeable"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "block": "",
      "color": "primary"
    },
    on: {
      "click": _vm.saveForLater
    }
  }, [_vm._v("Save for Later")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.readyToSend,
      "block": "",
      "color": "primary"
    },
    on: {
      "click": _vm.completeJob
    }
  }, [_vm._v("Save and Send")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "block": "",
      "color": "primary"
    },
    on: {
      "click": _vm.downloadJob
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("archive")]), _vm._v(" Download Zip File")], 1), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "imagePicker",
      "type": "file",
      "accept": "image/jpeg"
    },
    on: {
      "change": _vm.saveImages
    }
  }), _vm._v(" "), _c('canvas', {
    attrs: {
      "hidden": "",
      "id": "imageCanvas"
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "transition": "dialog-bottom-transition",
      "overlay": false
    },
    model: {
      value: (_vm.enterNote),
      callback: function($$v) {
        _vm.enterNote = $$v
      },
      expression: "enterNote"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.enterNote = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Note")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveNote.apply(null, arguments)
      }
    }
  }, [_vm._v("Save Note")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs10": "",
      "offset-xs1": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Add notes here"
    },
    model: {
      value: (_vm.currentNote),
      callback: function($$v) {
        _vm.currentNote = $$v
      },
      expression: "currentNote"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "transition": "dialog-bottom-transition",
      "overlay": false
    },
    model: {
      value: (_vm.fullImage),
      callback: function($$v) {
        _vm.fullImage = $$v
      },
      expression: "fullImage"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.fullImage = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.changeImage
    }
  }, [_vm._v("Change Image")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.fullImageSrc
    }
  })])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    model: {
      value: (_vm.testingDialog),
      callback: function($$v) {
        _vm.testingDialog = $$v
      },
      expression: "testingDialog"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.testingDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Testing")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.testingDialog = false
      }
    }
  }, [_vm._v("Save Test")])], 1)], 1), _vm._v(" "), _c('testing', {
    attrs: {
      "testType": _vm.testType,
      "testID": _vm.testID
    },
    on: {
      "testId": _vm.saveTest
    }
  })], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    model: {
      value: (_vm.rdlTestDialog),
      callback: function($$v) {
        _vm.rdlTestDialog = $$v
      },
      expression: "rdlTestDialog"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-toolbar-title', [_vm._v("RDL Testing")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.rdlTestDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "100vh"
    },
    attrs: {
      "id": "rdlFrame",
      "src": "https://m.digidown.net/rdl_status/"
    }
  })], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    model: {
      value: (_vm.dlTestDialog),
      callback: function($$v) {
        _vm.dlTestDialog = $$v
      },
      expression: "dlTestDialog"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-toolbar-title', [_vm._v("DL Testing")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        _vm.dlTestDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "100vh"
    },
    attrs: {
      "id": "dlFrame",
      "src": "https://cwelite.aquariusit.com/dl-status/"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16332f22","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CurrentJob.vue
// module id = 665
// module chunks = 1